import Vue from "vue";
import Privacy from "./App.vue";
import router from "./router";
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(Privacy),
}).$mount("#privacy");
